import { render, staticRenderFns } from "./PointNetridecashTechcoinConfirm.vue?vue&type=template&id=139874e6"
import script from "./PointNetridecashTechcoinConfirm.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports